// constants/tokens.js
export const T = {
  bg0: "#080808",
  bg1: "#0f0f0f",
  bg2: "#161616",
  bg3: "#1e1e1e",
  bg4: "#252525",
  border: "#222",
  borderHover: "#383838",
  textPrimary: "#e8e8e8",
  textSecondary: "#888",
  textDim: "#444",
  green: "#7ab648",
  greenGlow: "#7ab64830",
  greenDim: "#1a2e0a",
  greenBorder: "#3d5a1c",
  greenText: "#b8dc8a",
  red: "#d95050",
  redDim: "#2d1212",
  redBorder: "#4a1c1c",
  redText: "#e8a0a0",
  amber: "#d4922a",
  amberDim: "#2a1e0a",
  amberBorder: "#45310f",
  amberText: "#eec27a",
  blue: "#4a8fd4",
  blueDim: "#0e1d30",
  blueBorder: "#1c3a5a",
  blueText: "#80b8e8",
  fontMono: "'JetBrains Mono', 'Fira Code', monospace",
  radius: "6px",
  radiusSm: "4px",
  radiusLg: "10px",
};
